/* The order status lookup (snippets/order-find.liquid): an order number posted to Forge with fetch, and Forge's answer
   shown in place. Forge answers the same for every number, so nothing here says whether an order exists. Without
   this script the form posts to Forge, whose own page takes over. When Forge can't be reached (offline, not deployed
   yet, a site not on its CORS list) or says there were too many tries, the answer is a calm one with the phone.
   Strings come from the form's data attributes (locales/en.default.json, order_status.*). */
(function () {
  if (window.tpOrderFind) return;
  window.tpOrderFind = true;

  // Forge drops a form posted within 2 s of its clock as a bot's, so a quick visitor waits out the rest here.
  var MIN_MS = 2500;
  // Forge refuses a clock a day old; one older than this is asked for again.
  var STALE_MS = 6 * 3600 * 1000;
  var SHAPE = /^[A-Z0-9][A-Z0-9-]{0,31}$/;
  var turnstile = null;

  // As Forge reads it: "#5701", " 5701 ", and "Order #5701" are 5701.
  function normalize(v) {
    return String(v || '').replace(/[\s#]+/g, '').toUpperCase().replace(/^ORDER(?=[A-Z0-9])/, '');
  }

  // Cloudflare's script, once, and only when Forge has Turnstile on.
  function loadTurnstile() {
    if (!turnstile) {
      turnstile = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        s.async = true;
        s.onload = function () { if (window.turnstile) resolve(window.turnstile); else reject(new Error('turnstile')); };
        s.onerror = function () { reject(new Error('turnstile')); };
        document.head.appendChild(s);
      });
    }
    return turnstile;
  }

  function setup(form) {
    var d = form.dataset;
    var input = form.elements.number;
    var stamp = form.elements.opened;
    var button = form.querySelector('button[type="submit"]');
    var msg = form.querySelector('.find-m');
    var ts = form.querySelector('.find-ts');
    var clock = null;
    var widget = null;
    var busy = false;

    // A printed number's tel: address, made of its digits alone as the snippet makes data-tel; '' for one that can't be dialed.
    function dial(phone) {
      var digits = String(phone || '').replace(/\D+/g, '');
      if (digits.length === 10) return 'tel:+1' + digits;
      if (digits.length === 11 && digits.charAt(0) === '1') return 'tel:+' + digits;
      if (digits.length >= 7 && digits.length <= 15) return 'tel:' + (/^\s*\+/.test(String(phone)) ? '+' : '') + digits;
      return '';
    }

    // The message, with the phone number in it as a link to dial: "[phone]" in the theme's own words, or, given the
    // number Forge's words print (its answer's phone field), that number. Text nodes only: nothing in an answer is markup.
    function say(text, phone) {
      var mark = '[phone]';
      var shown = d.phone;
      var href = d.tel;
      if (typeof phone === 'string' && phone.length <= 40 && dial(phone)) {
        mark = shown = phone;
        href = dial(phone);
      }
      msg.textContent = '';
      String(text || '').split(mark).forEach(function (part, i) {
        if (i > 0) {
          var a = document.createElement('a');
          a.href = href;
          a.textContent = shown;
          msg.appendChild(a);
        }
        msg.appendChild(document.createTextNode(part));
      });
    }

    // The number Forge's answer prints: its phone field ('' for a brand with none), or the theme's own from a Forge
    // that doesn't send one.
    function phoneOf(json) {
      return typeof json.phone === 'string' ? json.phone : d.phone;
    }

    // Forge's clock (the sealed moment the form was served) and Turnstile's key, asked when the form is first used.
    function prime() {
      if (clock && Date.now() - clock.at < STALE_MS) return clock.ready;
      var c = { at: Date.now() };
      c.ready = fetch(form.action, { headers: { Accept: 'application/json' }, credentials: 'omit', cache: 'no-store' })
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then(function (j) {
          if (!j || !j.opened) throw new Error('no clock');
          c.at = Date.now();
          stamp.value = j.opened;
          if (j.site_key && widget === null) {
            return loadTurnstile().then(function (t) {
              ts.hidden = false;
              widget = t.render(ts, { sitekey: j.site_key, appearance: 'interaction-only', size: 'flexible', theme: 'light' });
              return true;
            }, function () { return true; });
          }
          return true;
        })
        .catch(function () { if (clock === c) clock = null; return false; });
      clock = c;
      return c.ready;
    }

    form.addEventListener('focusin', function () { prime(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      var number = normalize(input.value);
      if (!SHAPE.test(number)) {
        input.setAttribute('aria-invalid', 'true');
        say(d.invalid);
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');
      busy = true;
      var posted = false;
      // aria-disabled, not disabled: a disabled button would drop the keyboard's focus.
      button.setAttribute('aria-disabled', 'true');
      say(d.sending);

      prime()
        .then(function (ok) {
          if (!ok) throw new Error('unreachable');
          var wait = clock.at + MIN_MS - Date.now();
          return new Promise(function (resolve) { setTimeout(resolve, Math.max(0, wait)); });
        })
        .then(function () {
          // Turnstile, when it's on, may still be finishing its token: up to 6 s more, then Forge says if it's missing.
          if (widget === null || !window.turnstile) return null;
          return new Promise(function (resolve) {
            var tries = 0;
            (function poll() {
              if (window.turnstile.getResponse(widget) || ++tries > 40) resolve();
              else setTimeout(poll, 150);
            })();
          });
        })
        .then(function () {
          var body = new URLSearchParams(new FormData(form));
          body.set('number', number);
          posted = true;
          // A form body and an Accept header only: a simple request, so no preflight.
          return fetch(form.action, { method: 'POST', body: body, headers: { Accept: 'application/json' }, credentials: 'omit' });
        })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, json: j || {} }; });
        })
        .then(function (res) {
          if (res.status === 200) {
            say(res.json.message || d.sent, phoneOf(res.json));
          } else if (res.status === 422 && res.json.message) {
            say(res.json.message, phoneOf(res.json));
          } else if (res.status === 429) {
            say(d.busy);
          } else {
            say(d.failed);
          }
        })
        .catch(function () { say(d.failed); })
        .then(function () {
          busy = false;
          button.removeAttribute('aria-disabled');
          // Cloudflare takes a token once: whatever came back (even a reply the browser couldn't read), the next
          // lookup from this form needs a fresh one.
          if (posted && widget !== null && window.turnstile) {
            try { window.turnstile.reset(widget); } catch (err) { /* the next poll waits, and Forge says if it's missing */ }
          }
        });
    });

    // Folded behind "View order status" (the header's tray): opening it starts the clock and puts the cursor in the field.
    var fold = form.closest('details.find-d');
    if (fold) {
      fold.addEventListener('toggle', function () {
        if (!fold.open) return;
        prime();
        input.focus();
      });
    }
  }

  document.querySelectorAll('form[data-order-find]').forEach(setup);
})();
